<template>
    <div class="distance-calculator__content">
        <h2 class="distance-calculator__content__title">{{ fields?.title }}</h2>
        <div class="distance-calculator__content__form">
            <SearchSelect :items="items" :placeholder="fields?.departure.label" @update:value="updateDeparture"
                ref="departureSearchSelect" />
            <SearchSelect :items="items" :placeholder="fields?.arrival.label" @update:value="updateArrival"
                ref="arrivalSearchSelect" />
            <button @click="calculateDistance" class="link-button primary" :disabled="isDisabled"
                :class="{ 'disabled-button': isDisabled }">
                <span v-if="loading" class="loading">
                    <span class="spinner"></span>
                </span>
                <span v-else>{{ fields?.buttontext }}</span>
            </button>
        </div>

        <DistanceResult :distance="distanceResult" :departureName="tempdepartureName" :arrivalName="temparrivalName"
            v-if="distanceResult !== null" :resultText="fields?.result" :button="fields?.button"
            :show_button="fields?.show_button" />
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { getDistanceReport } from '../api/APIService';
import Airports, { InitialData } from '../types/types';
import SearchSelect from './SearchSelect/SearchSelect.vue';
import DistanceResult from './DistanceResult/DistanceResult.vue';

const departure = ref('');
const arrival = ref('');
const tempdepartureName = ref('');
const temparrivalName = ref('');
const departureName = ref('');
const arrivalName = ref('');
const items = ref<Airports[]>([]);
const distanceResult = ref(null);
const loading = ref(false);
const departureSearchSelect = ref<InstanceType<typeof SearchSelect> | null>(null);
const arrivalSearchSelect = ref<InstanceType<typeof SearchSelect> | null>(null);

const props = defineProps<{
    fields: InitialData | null;
}>();

const isDisabled = computed(() => {
    return !departure.value || !arrival.value;
});

const updateDeparture = (value: { code: string; name: string }) => {
    departure.value = value.code;
    departureName.value = value.name;
};

const updateArrival = (value: { code: string; name: string }) => {
    arrival.value = value.code;
    arrivalName.value = value.name;
};

const calculateDistance = async () => {
    try {
        loading.value = true;
        const data = {
            function: 'getDistanceReport',
            url: 'distancereport',
            payload: {
                fromAirport: departure.value,
                toAirport: arrival.value
            }
        };

        const response = await getDistanceReport(data);
        if (response.status === 200 && typeof response.data !== 'string') {
            distanceResult.value = response.data.GetDistanceReportResult;
            tempdepartureName.value = departureName.value;
            temparrivalName.value = arrivalName.value;
            resetFields();

        }
    } catch (error) {
        console.error('Error fetching data:', props.fields?.error);
    } finally {
        loading.value = false;
    }
};

const resetFields = () => {
    departure.value = '';
    arrival.value = '';
    departureName.value = '';
    arrivalName.value = '';
    departureSearchSelect.value?.clearSearchFunction();
    arrivalSearchSelect.value?.clearSearchFunction();
};
</script>